import { MainLink } from "./NavHeading"

export const dummyMainLinks: MainLink[] = [
  {
    label: "Products",
    hasSubMenu: true,
    subMenu: {
      title: "Our Products",
      content: [
        {
          label: "Card Machines",
          menuContent: [
            {
              type: "display",
              hoverZoom: true,
              title: "Card Machines Overview",
              link: {
                label: "Overview",
                link: "/za/shop/card-machines/",
                description:
                  "Find the perfect card machine to suit how you sell.",
                image:
                  "https://a.storyblok.com/f/111633/356x200/2f825a0c27/khumo-and-khumo-print.png",
              },
            },
            {
              type: "link",
              title: "Card Machines",
              links: [
                {
                  label: "Khumo",
                  link: "/za/khumo/",
                  description: "Payments and POS in one smart device",
                  image:
                    "https://a.storyblok.com/f/111633/84x84/560216bd77/khumo-blue.png",
                },
                {
                  label: "Khumo print",
                  link: "/za/khumo-print/",
                  description: "Everything Khumo plus built in printer",
                  image:
                    "https://a.storyblok.com/f/111633/84x84/08dcd44212/khumo-print-blue.png",
                },
                {
                  label: "Neo Touch",
                  link: "/za/neo-touch/",
                  description: "Pairs with POS for countertop sales",
                  image:
                    "https://a.storyblok.com/f/111633/84x84/62b847071d/neo-touch-blue.png",
                },
              ],
              ctaLink: "/za/shop/card-machines/?tab=Compare",
              ctaText: "Compare All",
            },
          ],
        },
        {
          label: "Point Of Sale Systems",
          menuContent: [
            {
              type: "display",
              hoverZoom: true,
              title: "Overview",
              link: {
                label: "POS System Overview",
                link: "/za/point-of-sale/",
                description:
                  "Explore POS systems built to save you time, money, and guesswork",
                image:
                  "https://a.storyblok.com/f/111633/356x200/40d6310d4a/pos-overview.png",
              },
            },
            {
              type: "link",
              title: "Point of Sale Systems",
              links: [
                {
                  label: "Yoco Counter",
                  link: "/za/point-of-sale/yoco-counter/",
                  description: "Payments and POS in one out of the box system",
                  image:
                    "https://a.storyblok.com/f/111633/84x84/0fb5232168/counter-icon.png",
                },
                {
                  label: "Yoco Table",
                  link: "/za/point-of-sale/table/",
                  description: "Restaurant management system for hospitality",
                  image:
                    "https://a.storyblok.com/f/111633/84x84/eb96bf70a6/table-icon.png",
                },
                {
                  label: "iPad bundle",
                  link: "/za/point-of-sale/ipad-bundle/",
                  description: "Turn your iPad into a complete POS system",
                  image:
                    "https://a.storyblok.com/f/111633/84x84/084c06e90c/ipad-icon.png",
                },
              ],
            },
          ],
        },
        {
          label: "Online Payments",
          menuContent: [
            {
              type: "display",
              title: "Overview",
              hoverZoom: true,
              link: {
                label: "Online Payments Overview",
                link: "/za/online-payment/",
                description:
                  "Accept payments anywhere - with links, invoices and powerful e-commerce tools",
                image:
                  "https://a.storyblok.com/f/111633/356x200/988572b6e0/payment-overview.png",
              },
            },
            {
              type: "link",
              title: "Online Payments",
              links: [
                {
                  label: "Gateway",
                  link: "/za/gateway/",
                  description: "Checkout that fits your site",
                  image:
                    "https://a.storyblok.com/f/111633/24x24/ad4b0091c4/online-store-24px.svg",
                  imageSize: "small",
                },
                {
                  label: "Payment Link",
                  link: "/za/payment-link/",
                  description: "Share a link, get paid",
                  image:
                    "https://a.storyblok.com/f/111633/24x24/fbb548e28c/payment-link-24px.svg",
                  imageSize: "small",
                },
                {
                  label: "Invoices",
                  link: "/za/invoicing/",
                  description: "Invoices with one-click pay",
                  image:
                    "https://a.storyblok.com/f/111633/24x24/e7c834261c/wip-receipt-24px.svg",
                  imageSize: "small",
                },
              ],
            },
            {
              type: "link",
              title: "Integrations",
              links: [
                {
                  label: "Partners",
                  link: "/za/integrations/partners/",
                  description: "Connect to leading platforms",
                },
                {
                  label: "e-Commerce",
                  link: "/za/gateway/",
                  description: "Plug-ins for every webshop",
                },
              ],
            },
          ],
        },
        {
          label: "Manage Cashflow",
          menuContent: [
            {
              type: "link",
              title: "Manage Cashflow",
              links: [
                {
                  label: "Instant Payout",
                  link: "/za/instant-payouts/",
                  description:
                    "Get your money in minutes—direct to your account",
                  image:
                    "https://a.storyblok.com/f/111633/24x24/480f228054/capital-deductions-24px.svg",
                  imageSize: "small",
                },
                {
                  label: "Capital",
                  link: "/za/capital/",
                  description: "Restaurant management system for hospitality",
                  image:
                    "https://a.storyblok.com/f/111633/24x24/5a3d3855fc/yoco-capital-24px.svg",
                  imageSize: "small",
                },
              ],
            },
          ],
        },
        {
          label: "Yoco App",
          menuContent: [
            {
              type: "display",
              title: "Overview",
              hoverZoom: true,
              link: {
                label: "Yoco App Overview",
                link: "/za/app/",
                description: "Your back office wherever you go",
                image:
                  "https://a.storyblok.com/f/111633/356x200/913083bf07/app-overview.png",
              },
            },
          ],
        },
        {
          label: "Product Finder",
          menuContent: [
            {
              type: "display",
              title: "Overview",
              hoverZoom: true,
              link: {
                label: "Product Finder",
                link: "/za/product-finder/",
                description: "Find your perfect device fast",
                image:
                  "https://a.storyblok.com/f/111633/859x483/b8aee2ff2f/navigation-product-finder.png",
              },
            },
          ],
        },
      ],
    },
  },
  {
    label: "Industries",
    hasSubMenu: true,
    subMenu: {
      title: "Business Types",
      content: [
        {
          label: "Food & Beverage",
          menuContent: [
            {
              type: "display",
              hoverZoom: true,
              title: "Overview",
              link: {
                label: "Food & Beverage",
                link: "/za/food-and-beverages/",
                description: "Faster tables, simpler tips",
                image:
                  "https://a.storyblok.com/f/111633/534x301/fc9a87f447/food-beverage-overview.png",
              },
            },
          ],
        },
        {
          label: "Retail",
          menuContent: [
            {
              type: "display",
              hoverZoom: true,
              title: "Overview",
              link: {
                label: "Retail",
                link: "/za/retail/",
                description: "Smart tools for retail ops",
                image:
                  "https://a.storyblok.com/f/111633/534x301/27602e8a48/retail-overview.png",
              },
            },
          ],
        },
        {
          label: "Health & Beauty",
          menuContent: [
            {
              type: "display",
              title: "Overview",
              hoverZoom: true,
              link: {
                label: "Health & Beauty",
                link: "/za/health-and-beauty/",
                description: "Book, bill and take tips",
                image:
                  "https://a.storyblok.com/f/111633/534x301/1674552ba5/health-beauty-overview.png",
              },
            },
          ],
        },
        {
          label: "Services",
          menuContent: [
            {
              type: "display",
              title: "Overview",
              hoverZoom: true,
              link: {
                label: "Services",
                link: "/za/pro-services/",
                description: "Get paid for every service",
                image:
                  "https://a.storyblok.com/f/111633/534x301/60e41b8ff0/services-overview.png",
              },
            },
          ],
        },
      ],
    },
  },
  {
    label: "Why Yoco?",
    menuColumnBlocks: [
      {
        type: "link",
        title: "Why Yoco",
        links: [
          {
            label: "About",
            description: "Why businesses pick Yoco",
            link: "/za/about/",
          },
          {
            label: "Switching?",
            description: "Compare and switch easily",
            link: "/za/switch/",
          },
          {
            label: "New to Card Machines?",
            description: "Your first card reader guide",
            link: "/za/shop/card-machines/",
          },
          {
            label: "Contact Sales",
            description: "Speak to a payments expert",
            link: "/za/contact",
          },
        ],
      },
    ],
  },
  { label: "Pricing", link: "/za/pricing/" },
  { label: "Shop", link: "/za/shop/" },
]
